<template>
  <div>
    <section
      id="reject-content"
      class="container-fluid"
    >
      <h2>Putar Arah Tablet Anda ke Landscape untuk Mendapatkan Visual yang Lebih Baik.</h2>
      <img src="~/assets/img/reject-portrait.png">
      <h2>
        Jika Anda Memiliki Kendala,Silahkan Hubungi
        <a href="mailto:dok@yesdok.com" class="text-green">dok@yesdok.com</a>
      </h2>
    </section>
    <section v-if="$store.state.user.auth.userData" id="main-content">
      <template>
        <client-only>
          <b-navbar id="consoleHeader" sticky toggleable="md" :style="($route.name === 'console' && isChromeIOS) ? 'position: inherit;' : ''">
            <b-navbar-brand :to="$store.state.user.auth.role === 'admin' ? '' : '/console'" class="ml-3 d-flex align-items-center" @click="$tracker({ action: 'cta_nav_yesdok_logo', category: 'navbar' })">
              <img src="https://ydbucketstorage.s3.ap-southeast-1.amazonaws.com/img/v3/main/brand.png">

              <div class="d-flex flex-column ml-2">
                <span class="title-console-header">
                  {{ isPsychologist ? 'PANEL KONSULTASI' : 'DOCTOR PANEL' }}
                </span>
                <div class="title-version">
                  <span class="version-watermark">V{{ $store.state.webVersion }}</span>
                </div>
              </div>
            </b-navbar-brand>
            <b-navbar-nav class="navbar-content align-items-center text-dark">
              <div class="navbar-content d-sm-none d-md-none d-lg-flex">
                <template>
                  <template v-for="(nav, index) in filteredListNavbar">
                    <a
                      v-if="nav.external"
                      :key="index"
                      :href="nav.path"
                      rel="noopener"
                    >
                      <div class="list-content" :class="{'active':$route.path===nav.path}" @click="trackingNavbar(nav)">
                        <img class="list-image" :src="$route.path===nav.path ? nav.imageActive : nav.imageNotActive" width="28" height="28" :alt="nav.title">
                        <span class="list-title">{{ nav.title }}</span>
                      </div>
                    </a>
                    <nuxt-link v-else :key="index" :to="nav.path">
                      <div class="list-content" :class="{'active':$route.path===nav.path}" @click="trackingNavbar(nav)">
                        <img class="list-image" :src="$route.path===nav.path ? nav.imageActive : nav.imageNotActive" width="28" height="28" :alt="nav.title">
                        <span class="list-title">{{ nav.title }}</span>
                      </div>
                    </nuxt-link>
                  </template>
                  <!-- <nuxt-link v-for="(nav,index) in filteredListNavbar" :key="index" :to="nav.path">
                    <div class="list-content" :class="{'active':$route.path===nav.path}" @click="trackingNavbar(nav)">
                      <img class="list-image" :src="$route.path===nav.path ? nav.imageActive : nav.imageNotActive" width="28" height="28" :alt="nav.title">
                      <span class="list-title">{{ nav.title }}</span>
                    </div>
                  </nuxt-link> -->
                </template>
              </div>
              <el-button v-click-outside="closeNavbar" :icon="`el-icon-${navbar ? 'close': 'arrow-down'}`" circle class="d-sm-block d-md-block d-lg-none" @click="navbar = !navbar" />
              <transition name="fade" class="row">
                <div v-show="navbar" class="position-absolute pop-position z-10 col-12 shadow-lg bg-white left-0 mt-2 text-center">
                  <nuxt-link v-for="(nav,index) in filteredListNavbar" :key="index" :to="nav.path">
                    <div class="list-content border-b" :class="{'active':$route.path===nav.path}">
                      <img class="list-image mr-2 lg:mr-0" :src="$route.path===nav.path ? nav.imageActive : nav.imageNotActive" width="28" height="28" :alt="nav.title">
                      <span class="list-title">{{ nav.title }}</span>
                    </div>
                  </nuxt-link>
                </div>
              </transition>
            </b-navbar-nav>
            <b-navbar-nav class="d-flex align-items-center">
              <b-nav-item-dropdown
                v-if="$store.state.user.auth.isAuth && $store.state.user.auth.userData"
                ref="profile"
                right
                class="mr-3"
                @mouseenter.native="handleOpenTitle('profile', 'Profile')"
              >
                <!-- Using 'button-content' slot -->
                <template #button-content @click="closeNotif">
                  <div
                    class="font-14px d-none d-xl-inline-block text-right mr-2"
                    style="
                    vertical-align: middle;
                    width: 160px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                    font-family: 'Rubik Medium', sans-serif;
                  "
                  >
                    <span v-if="$store.state.user.auth.role === 'doctor' && $store.state.user && $store.state.user.auth && $store.state.user.auth.userData">{{
                      $store.state.user.auth.userData.Firstname +
                        " " +
                        $store.state.user.auth.userData.Lastname
                    }}</span>
                    <span v-else-if="$store.state.user.auth.role === 'admin'">{{
                      $store.state.user.auth.userData.Name
                    }}</span>
                  </div>

                  <img
                    v-if="!errorImage && $store.state.user.auth.userData.AvatarUrl"
                    :src="$store.state.user.auth.userData.AvatarUrl"
                    width="40px"
                    height="40px"
                    style="object-fit: cover; border-radius: 100%"
                    class="mr-2"
                    @error="handleErrorImage"
                  >
                  <img
                    v-else
                    src="@/assets/img/user-no-img.jpg"
                    alt=""
                    width="40px"
                    height="40px"
                    style="object-fit: cover; border-radius: 100%"
                    class="mr-2"
                  >
                </template>
                <b-dropdown-item
                  v-if="$store.state.user.auth.role === 'doctor'"
                  :disabled="$store.state.consultation.callStatus === 'IN_CALL'"
                  to="/console/profile"
                  @click="$tracker({ action: 'cta_nav_profile', category: 'navbar' })"
                >
                  Profil
                </b-dropdown-item>
                <b-dropdown-item :disabled="$store.state.consultation.callStatus === 'IN_CALL'" href="#" @click.prevent="logout()">
                  Keluar
                </b-dropdown-item>
              </b-nav-item-dropdown>

              <b-dropdown
                v-if="$route.path === '/console/calendar'"
                id="dropdown-share-social"
                ref="shareLink"
                variant="primary"
                class="mr-3"
                @mouseenter.native="handleOpenTitle('shareLink', 'Share Link')"
              >
                <template #button-content>
                  <img src="@/assets/img/share.svg" alt="">
                </template>
                <b-dropdown-item @click="handleLink('fb')">
                  <div class="d-flex align-items-center">
                    <img class="thumb mr-2" :src="require(`~/static/img/FACEBOOK.png`)">
                    <strong>Facebook</strong>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="handleLink('mail')">
                  <div class="d-flex align-items-center">
                    <img class="thumb mr-2" :src="require(`~/static/img/EMAIL.png`)">
                    <strong>Email</strong>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="handleLink('in')">
                  <div class="d-flex align-items-center">
                    <img class="thumb mr-2" :src="require(`~/static/img/LINKEDIN.png`)">
                    <strong>LinkedIn</strong>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="handleLink('tw')">
                  <div class="d-flex align-items-center">
                    <img class="thumb mr-2" :src="require(`~/static/img/TWITTER.png`)">
                    <strong>Twitter</strong>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="handleLink('wa')">
                  <div class="d-flex align-items-center">
                    <img class="thumb mr-2" :src="require(`~/static/img/WA.png`)">
                    <strong>WhatsApp</strong>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item @click="handleLink('copy')">
                  <div class="d-flex align-items-center">
                    <img class="thumb mr-2" :src="require(`~/static/img/COPY-LINK.png`)">
                    <strong>Salin Tautan</strong>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
              <el-popover
                v-if="$store.state.user.auth.role === 'doctor'"
                ref="notification"
                v-model="notifPopover"
                placement="bottom"
                popper-class="p-0 z-1000"
                :visible-arrow="false"
                width="550"
                trigger="click"
                @mouseenter.native="handleOpenTitle('notification', 'Notification')"
              >
                <b-button slot="reference" variant="primary" class="mr-3 font-rubik-medium notification-button" @click=" $tracker({ action: 'cta_nav_notif', category: 'navbar' })">
                  <span class="notify">
                    <font-awesome-icon icon="bell" size="lg" />
                    <span v-if="badgeDotActive && notificationsUnRead.length > 0" class="badge-dot" style="right: -1px;top: -3px;" />
                    <span v-if="badgeDotActive && notificationsUnRead.length > 0" class="badge-dot animate-ping" style="right: -1px;top: -3px;" />
                  </span>
                </b-button>

                <template v-if="$route.name === 'console' || $route.name === 'console-profile'" #default>
                  <el-tabs v-model="tabsNotif" type="card" class="tabs-notify" @tab-click="trackTabNotifClick">
                    <el-tab-pane label="Belum dibaca" name="unread">
                      <div class="d-flex px-3 py-2 border-bottom">
                        <div class="form-group-search">
                          <font-awesome-icon icon="search" class="icon-search" />
                          <b-form-input v-model="searchNotif" class="form-search-notif form-control" placeholder="Cari pemberitahuan..." />
                        </div>
                      </div>
                      <div v-if="notificationsUnRead && notificationsUnRead.length > 0" ref="notif" class="font-black" @scroll="scrolled">
                        <div v-for="(notif, i) in notificationsUnRead" :key="i" class="notify-list cursor-pointer bg-blue" @click="goToConsultation(notif.ID, notif.RelationID,false)">
                          <template v-if="['CLINIC_INVITATION','CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE', 'CLINIC_CANCEL_INVITE_DOCTOR', 'CLINIC_TAGGING_DOCTOR'].includes(notif.Type)">
                            <img
                              v-if="notif && ['CLINIC_TAGGING_DOCTOR'].includes(notif.Type)"
                              :src="notif.Clinic && notif.Clinic.Clinic && notif.Clinic.Clinic.ClinicLogo? notif.Clinic.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                            <img
                              v-else-if="notif"
                              :src="notif.Clinic && notif.Clinic.ClinicLogo? notif.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                            <img
                              v-else
                              src="@/assets/img/user-no-img2.png"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else-if="['UPDATE_PROFILE_REJECTED', 'DOCTOR_NO_ANSWER', 'BOTH_NO_ANSWER', 'UPDATE_PROFILE_APPROVED'].includes(notif.Type)">
                            <img
                              src="@/assets/icon/img-icon-yesdok.png"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else>
                            <img :src="notif.ImageUrl ? notif.ImageUrl : require('@/assets/img/user-no-img2.png')" width="45px" height="45px" class="mr-2 rounded-circle object-fit-cover profile-image" alt="">
                          </template>
                          <div class="w-100">
                            <span class="break-word" v-html="notif.text" />
                            <span v-if="checkYesterday(notif.Timestamp)" class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('DD/MM/YYYY') }}</span>
                            <span v-else class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('HH:mm') }}</span>
                            <b-button
                              v-if="notif.Type === 'REFUND'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToConsultation(notif.ID, notif.RelationID,true)"
                            >
                              Lihat penangguhan
                            </b-button>
                            <b-button
                              v-else-if="notif.Type === 'CLINIC_INVITATION'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToProfile(notif.Clinic.ID)"
                            >
                              Lihat detail
                            </b-button>
                            <b-button
                              v-else-if="['UPDATE_PROFILE_REJECTED', 'UPDATE_PROFILE_APPROVED'].includes(notif.Type)"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="$router.push('/console/profile')"
                            >
                              Lihat detail
                            </b-button>
                            <b-button
                              v-else-if="['CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE', 'CLINIC_TAGGING_DOCTOR'].includes(notif.Type)"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="$router.push('/console/calendar')"
                            >
                              Lihat Jadwal
                            </b-button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="font-black">
                        <h6 class="px-3 pt-3 pb-2 text-grey text-center">
                          Tidak ada pemberitahuan terbaru
                        </h6>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="Sudah dibaca" name="read">
                      <div class="d-flex px-3 py-2 border-bottom">
                        <div class="form-group-search">
                          <font-awesome-icon icon="search" class="icon-search" />
                          <b-form-input v-model="searchNotif" class="form-search-notif form-control" placeholder="Cari pemberitahuan..." />
                        </div>
                      </div>
                      <div v-if="notificationsRead && notificationsRead.length > 0" ref="notif" class="font-black" @scroll="scrolled">
                        <div v-for="(notif, i) in notificationsRead" :key="i" class="notify-list">
                          <template v-if="['CLINIC_INVITATION','CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE', 'CLINIC_CANCEL_INVITE_DOCTOR', 'CLINIC_TAGGING_DOCTOR'].includes(notif.Type)">
                            <img
                              v-if="notif && ['CLINIC_TAGGING_DOCTOR'].includes(notif.Type)"
                              :src="notif.Clinic && notif.Clinic.Clinic && notif.Clinic.Clinic.ClinicLogo? notif.Clinic.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                            <img
                              v-else-if="notif.Clinic"
                              :src="notif.Clinic.ClinicLogo !== '' && notif.Clinic.ClinicLogo !== null ? notif.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                            <img
                              v-else
                              src="@/assets/img/user-no-img2.png"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else-if="['UPDATE_PROFILE_REJECTED', 'DOCTOR_NO_ANSWER', 'BOTH_NO_ANSWER', 'UPDATE_PROFILE_APPROVED'].includes(notif.Type)">
                            <img
                              src="@/assets/icon/img-icon-yesdok.png"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else>
                            <img :src="notif.ImageUrl !== '' && notif.ImageUrl !== null ? notif.ImageUrl : require('@/assets/img/user-no-img2.png')" width="45px" height="45px" class="mr-2 rounded-circle object-fit-cover" alt="">
                          </template>
                          <div class="w-100">
                            <span class="break-word" v-html="notif.text" />
                            <span v-if="checkYesterday(notif.Timestamp)" class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('DD/MM/YYYY') }}</span>
                            <span v-else class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('HH:mm') }}</span>
                            <b-button
                              v-if="notif.Type === 'REFUND'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px"
                              @click="goToConsultation(notif.ID, notif.RelationID,true)"
                            >
                              Lihat penangguhan
                            </b-button>
                            <b-button
                              v-else-if="notif.Type === 'CLINIC_INVITATION' && notif.Clinic"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px"
                              @click="goToProfile(notif.Clinic.ID)"
                            >
                              Lihat detail
                            </b-button>
                            <b-button
                              v-else-if="['CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE', 'CLINIC_TAGGING_DOCTOR'].includes(notif.Type)"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="$router.push('/console/calendar')"
                            >
                              Lihat Jadwal
                            </b-button>
                            <b-button
                              v-else-if="['UPDATE_PROFILE_REJECTED', 'UPDATE_PROFILE_APPROVED'].includes(notif.Type)"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="$router.push('/console/profile')"
                            >
                              Lihat detail
                            </b-button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="font-black">
                        <h6 class="px-3 pt-3 pb-2 text-grey text-center">
                          Tidak ada pemberitahuan terbaru
                        </h6>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </template>
                <template v-else #default>
                  <el-tabs v-model="tabsNotif" type="card" class="tabs-notify" @tab-click="trackTabNotifClick">
                    <el-tab-pane label="Belum dibaca" name="unread">
                      <div class="d-flex px-3 py-2 border-bottom">
                        <div class="form-group-search">
                          <font-awesome-icon icon="search" class="icon-search" />
                          <b-form-input v-model="searchNotif" class="form-search-notif form-control" placeholder="Cari pemberitahuan..." />
                        </div>
                      </div>
                      <div v-if="notificationsUnRead && notificationsUnRead.length > 0" ref="notif" class="font-black" @scroll="scrolled">
                        <div v-for="(notif, i) in notificationsUnRead" :key="i" class="notify-list cursor-pointer bg-blue" @click="goToConsultation(notif.ID, notif.RelationID,false)">
                          <template v-if="['CLINIC_INVITATION','CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE'].includes(notif.Type)">
                            <img
                              v-if="notif"
                              :src="notif.Clinic && notif.Clinic.ClinicLogo !== '' && notif.Clinic.ClinicLogo !== null ? notif.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else-if="['CLINIC_REJECTED_SCHEDULED', 'CLINIC_APPROVED_SCHEDULED'].includes(notif.Type)">
                            <img
                              v-if="notif"
                              :src="notif.Clinic && notif.Clinic.Clinic.ClinicLogo !== '' && notif.Clinic.Clinic.ClinicLogo !== null ? notif.Clinic.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else>
                            <img :src="notif.ImageUrl !== '' && notif.ImageUrl !== null ? notif.ImageUrl : require('@/assets/img/user-no-img2.png')" width="45px" height="45px" class="mr-2 rounded-circle object-fit-cover profile-image" alt="">
                          </template>
                          <div class="w-100">
                            <template v-if="notif.Type === 'CLINIC_REQUEST_SCHEDULE' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Clinic && notif.Clinic.ClinicName }}</b> mengundang Anda di jadwal
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      <template v-if="$moment(notif.Clinic.Start * 1000).format('DD') === $moment(notif.Clinic.End * 1000).format('DD')">
                                        {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                      </template>
                                      <template v-else>
                                        {{ $moment(notif.Clinic.Start * 1000).format('DD') }}-{{ $moment(notif.Clinic.End * 1000).format('DD MMMM YYYY') }}
                                      </template>
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}-{{ $moment(notif.Clinic.End * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="notif.Type === 'CLINIC_REJECTED_SCHEDULED' || notif.Type === 'CLINIC_APPROVED_SCHEDULED' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Clinic && notif.Clinic.Clinic.ClinicName }}</b> {{ `${notif.Type === 'CLINIC_REJECTED_SCHEDULED' ? 'menolak permintaan jadwal anda:' : 'menerima permintaan jadwal anda:'}` }}
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      <template v-if="$moment(notif.Clinic.Start * 1000).format('DD') === $moment(notif.Clinic.End * 1000).format('DD')">
                                        {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                      </template>
                                      <template v-else>
                                        {{ $moment(notif.Clinic.Start * 1000).format('DD') }}-{{ $moment(notif.Clinic.End * 1000).format('DD MMMM YYYY') }}
                                      </template>
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}-{{ $moment(notif.Clinic.End * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="notif.Type === 'PATIENT_BOOK_SCHEDULE' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Patient }}</b> telah membuat janji konsultasi untuk
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="notif.Type === 'PATIENT_BOOK_RESCHEDULE' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Patient }}</b> telah mengajukan <b>jadwal ulang</b> di jadwal Anda:
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <span v-else class="break-word" v-html="notif.text" />

                            <span v-if="checkYesterday(notif.Timestamp)" class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('DD/MM/YYYY') }}</span>
                            <span v-else class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('HH:mm') }}</span>
                            <b-button
                              v-if="notif.Type === 'REFUND'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToConsultation(notif.ID, notif.RelationID,true)"
                            >
                              Lihat penangguhan
                            </b-button>
                            <b-button
                              v-else-if="notif.Type === 'CLINIC_INVITATION'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToProfile(notif.Clinic.ID)"
                            >
                              Lihat detail
                            </b-button>
                            <b-button
                              v-else-if="['CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE', 'PATIENT_BOOK_SCHEDULE', 'PATIENT_BOOK_RESCHEDULE','CLINIC_APPROVED_SCHEDULED'].includes(notif.Type)"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToSchedule(notif)"
                            >
                              Lihat Jadwal
                            </b-button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="font-black">
                        <h6 class="px-3 pt-3 pb-2 text-grey text-center">
                          Tidak ada pemberitahuan terbaru
                        </h6>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="Sudah dibaca" name="read">
                      <div class="d-flex px-3 py-2 border-bottom">
                        <div class="form-group-search">
                          <font-awesome-icon icon="search" class="icon-search" />
                          <b-form-input v-model="searchNotif" class="form-search-notif form-control" placeholder="Cari pemberitahuan..." />
                        </div>
                      </div>
                      <div v-if="notificationsRead && notificationsRead.length > 0" ref="notif" class="font-black" @scroll="scrolled">
                        <div v-for="(notif, i) in notificationsRead" :key="i" class="notify-list">
                          <template v-if="['CLINIC_INVITATION','CLINIC_REQUEST_SCHEDULE','CLINIC_TERMINATED'].includes(notif.Type)">
                            <img
                              v-if="notif.Clinic"
                              :src="notif.Clinic.ClinicLogo !== '' && notif.Clinic.ClinicLogo !== null ? notif.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else-if="['CLINIC_REJECTED_SCHEDULED', 'CLINIC_APPROVED_SCHEDULED'].includes(notif.Type)">
                            <img
                              v-if="notif"
                              :src="notif.Clinic && notif.Clinic.Clinic.ClinicLogo !== '' && notif.Clinic.Clinic.ClinicLogo !== null ? notif.Clinic.Clinic.ClinicLogo : require('@/assets/img/user-no-img2.png')"
                              width="45px"
                              height="45px"
                              class="mr-2 rounded-circle object-fit-cover"
                              alt=""
                            >
                          </template>
                          <template v-else>
                            <img :src="notif.ImageUrl !== '' && notif.ImageUrl !== null ? notif.ImageUrl : require('@/assets/img/user-no-img2.png')" width="45px" height="45px" class="mr-2 rounded-circle object-fit-cover" alt="">
                          </template>
                          <div class="w-100">
                            <template v-if="notif.Type === 'CLINIC_REQUEST_SCHEDULE' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Clinic && notif.Clinic.ClinicName }}</b> mengundang Anda di jadwal
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      <template v-if="$moment(notif.Clinic.Start * 1000).format('DD') === $moment(notif.Clinic.End * 1000).format('DD')">
                                        {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                      </template>
                                      <template v-else>
                                        {{ $moment(notif.Clinic.Start * 1000).format('DD') }}-{{ $moment(notif.Clinic.End * 1000).format('DD MMMM YYYY') }}
                                      </template>
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}-{{ $moment(notif.Clinic.End * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="notif.Type === 'PATIENT_BOOK_SCHEDULE' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Patient }}</b> telah membuat janji konsultasi untuk
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <template v-else-if="notif.Type === 'PATIENT_BOOK_RESCHEDULE' && notif.Clinic">
                              <div class="break-word">
                                <b>{{ notif.Patient }}</b> telah mengajukan <b>jadwal ulang</b> di jadwal Anda:
                                <div class="mt-1">
                                  <div class="d-flex">
                                    <div class="mr-2">
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/calendar-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('DD MMMM YYYY') }}
                                    </div>
                                    <div>
                                      <img
                                        width="20px"
                                        height="20px"
                                        :src="require('@/assets/icon/clock-icon-blue.svg')"
                                      >
                                      {{ $moment(notif.Clinic.Start * 1000).format('HH:mm') }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </template>
                            <span v-else class="break-word" v-html="notif.text" />
                            <span v-if="checkYesterday(notif.Timestamp)" class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('DD/MM/YYYY') }}</span>
                            <span v-else class="d-flex justify-content-end time-position">{{ $moment(parseFloat(notif.Timestamp + '000')).format('HH:mm') }}</span>
                            <b-button
                              v-if="notif.Type === 'REFUND'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToConsultation(notif.ID, notif.RelationID,true)"
                            >
                              Lihat penangguhan
                            </b-button>
                            <b-button
                              v-else-if="notif.Type === 'CLINIC_INVITATION'"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToProfile(notif.Clinic.ID)"
                            >
                              Lihat detail
                            </b-button>
                            <b-button
                              v-else-if="['CLINIC_TERMINATED','CLINIC_REQUEST_SCHEDULE', 'PATIENT_BOOK_SCHEDULE', 'PATIENT_BOOK_RESCHEDULE'].includes(notif.Type)"
                              variant="outline-primary2"
                              pill
                              size="sm"
                              class="font-12px mt-3"
                              @click="goToSchedule(notif)"
                            >
                              Lihat Jadwal
                            </b-button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="font-black">
                        <h6 class="px-3 pt-3 pb-2 text-grey text-center">
                          Tidak ada pemberitahuan terbaru
                        </h6>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </template>
              </el-popover>
              <el-popover
                v-if="!connectedToTelegram && $store.state.user.auth.role !== 'admin'"
                ref="notificationTelegram"
                v-model="notifTelegram"
                placement="bottom"
                popper-class="py-2 px-4 z-1000 notification-telegram"
                width="400"
                trigger="click"
                @mouseenter.native="handleOpenTitle('notificationTelegram', 'Notification Telegram')"
              >
                <b-button slot="reference" variant="warning" class="mr-3 font-rubik-medium notification-telegram-button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="30"
                    height="30"
                    viewBox="0 0 48 48"
                    style="fill:#000000;"
                  >
                    <path fill="#29b6f6" d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z" />
                    <path fill="#fff" d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z" />
                    <path fill="#b0bec5" d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z" />
                    <path fill="#cfd8dc" d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z" />
                  </svg>
                </b-button>

                <template #default>
                  <p class="font-16px mb-1 font-rubik-medium">
                    Aktifkan Notifikasi Telegram?
                  </p>
                  <div class="d-flex">
                    <b-button variant="success" class="w-50 mr-2" @click="openTelegram(); $tracker({ action: 'cta_nav_telegram', category: 'navbar', label: 'activate_now' })">
                      Aktifkan Sekarang
                    </b-button>
                    <b-button variant="warning-2" class="w-50" @click="notifTelegram = false; $tracker({ action: 'cta_nav_telegram', category: 'navbar', label: 'activate_later' })">
                      Aktifkan Nanti
                    </b-button>
                  </div>
                </template>
              </el-popover>
              <b-button
                variant="success"
                class="mr-3 help-class position-relative"
                style="font-family: 'Rubik Medium', sans-serif;"
                @click="$router.push('/console/faq'); $tracker({ action: 'cta_nav_help_desk', category: 'navbar' })"
              >
                <img
                  src="@/assets/img/icon-warning.svg"
                  class="mr-xxl-2"
                  width="20"
                  height="20"
                  style="vertical-align: text-top"
                >
                <span class="d-xxl-none">Bantuan</span>
                <template v-if="newTnc || newFaq || newVideoTutorial">
                  <div style="position: absolute; top:0; right:10px;">
                    <span class="badge-dot" />
                    <span class="badge-dot animate-ping" />
                  </div>
                </template>
              </b-button>
            </b-navbar-nav>
          </b-navbar>
          <div class="d-md-block d-sm-none">
            <nuxt />
            <tutorial />
          </div>
          <section class="d-md-none d-sm-block">
            <div class="container">
              <div class="row">
                <div class="col-12 control-height">
                  <div class="control-empty">
                    <div class="div-flex">
                      <img class="icon-control" src="@/assets/img/warn.svg" alt="">
                    </div>
                    <br>
                    <div class="style-title">
                      Perlu diketahui
                    </div>
                    <br>
                    <div class="style-sub">
                      Halaman ini hanya bisa diakses melalui desktop/laptop/tablet/IPAD
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </client-only>
      </template>
      <modal-image
        v-if="$store.state.consultation.previewImage.modal"
        :url="$store.state.consultation.previewImage.url"
        @keyup.27="closeModal"
      >
        <template #close-modal>
          <b-button
            variant="danger"
            class="close-modal-image font-16px"
            @click="doPreviewImage(false)"
          >
            <font-awesome-icon
              icon="times-circle"
              style="font-size: 10pt"
              class="ml-2"
            />
            Tutup
          </b-button>
        </template>
      </modal-image>
      <create-pin v-if="!$store.state.user.auth.userData.HasPIN && $store.state.user.auth.role === 'doctor'" v-responsive.lg.xl />
      <b-modal
        id="modalOTP1"
        dialog-class="modalOTP"
        hide-header
        centered
        hide-header-close
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="row modal-verification">
          <div class="col-12 p-50x">
            <div class="d-flex justify-content-center mt-3">
              <img src="@/assets/img/otp-image.svg" width="110px" alt="">
            </div>
            <div class="text-title mt-3">
              KODE VERIFIKASI
            </div>
            <div v-if="$store.state.user.auth && $store.state.user.auth.userData && $store.state.user.auth.userData.Changes" class="text-subtitle mt-3">
              Kode verifikasi telah dikirim ke nomor
              <span class="text-phone">{{ $store.state.user.auth.userData.Changes.WhatsappNumber ? $store.state.user.auth.userData.Changes.WhatsappNumber : $store.state.user.auth.userData.Changes.Handphone ? $store.state.user.auth.userData.Changes.Handphone : $store.state.user.auth.userData.WhatsappNumber ? $store.state.user.auth.userData.WhatsappNumber : $store.state.user.auth.userData.Handphone ? $store.state.user.auth.userData.Handphone : '' }}</span>
            </div>
            <div class="d-flex justify-content-center mt-3 mb-4">
              <client-only>
                <v-otp-input
                  ref="otpInput"
                  input-classes="otp-input"
                  separator=""
                  :num-inputs="4"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOnChange"
                  @on-complete="handleOnComplete"
                />
              </client-only>
            </div>
            <div v-if="errorOTP" class="text-center text-red">
              Kode verifikasi tidak sah
            </div>
            <div v-if="counterIntervalObject" class="mt-2 mb-4 text-center fs-24x text-red">
              <div v-if="blocked">
                Anda telah melampaui limit permintaan pengiriman ulang kode.
              </div>
              <strong>{{ timerMinutes }}:{{ timerSeconds }}</strong>
            </div>
            <div class="mt-3">
              <b-button
                variant="primary-2"
                pill
                class="button-verification"
                size="md"
                :class="{'button-grey' : !otp || (otp && otp.length !== 4) || blocked}"
                :disabled="!otp || (otp && otp.length !== 4) || loadingVerify || blocked"
                @click="verifyOTP"
              >
                Verifikasi
              </b-button>
            </div>
            <div v-if="!counterIntervalObject" class="text-center text-green mt-3" @click="sendOtp">
              Kirim ulang kode
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalPhone"
        dialog-class="modalPhone"
        hide-header
        centered
        hide-header-close
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="row modal-phone">
          <div class="col-12 p-0">
            <div class="d-flex justify-content-center mt-3">
              <img src="@/assets/img/otp-image.svg" width="110px" alt="">
            </div>
            <div class="text-title mt-3">
              VERIFIKASI HANDPHONE
            </div>
            <div v-if="$store.state.user.auth && $store.state.user.auth.userData && $store.state.user.auth.userData.Changes" class="text-subtitle mt-3 mb-5">
              Nomor baru Anda
              <span class="text-phone">{{ $store.state.user.auth.userData.Changes.WhatsappNumber ? $store.state.user.auth.userData.Changes.WhatsappNumber : $store.state.user.auth.userData.Changes.Handphone ? $store.state.user.auth.userData.Changes.Handphone : $store.state.user.auth.userData.WhatsappNumber ? $store.state.user.auth.userData.WhatsappNumber : $store.state.user.auth.userData.Handphone ? $store.state.user.auth.userData.Handphone : '' }}</span> belum diverifikasi.
            </div>
            <div class="mt-3 d-flex justify-content-center">
              <b-button
                variant="primary-2"
                pill
                class="button-verification"
                size="md"
                :disabled="loadingUpdate"
                @click="sendOtp"
              >
                Verifikasi Sekarang
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalForceCompleteProfile"
        dialog-class="modalUnlink"
        hide-header
        centered
        hide-header-close
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="mt-2">
          <div class="row">
            <div class="col-12 d-flex flex-column align-items-center box">
              <img src="@/assets/img/modal-block2.png" alt="modal-block">
              <p class="title">
                Perhatian
              </p>
              <p class="description">
                Lengkapi <strong>Data Pribadi</strong> untuk di berikan informasi kepada Pasien dan lengkapi
                <strong>Data Rekening</strong> untuk transfer dana ke rekening Anda.
              </p>
              <nuxt-link
                v-if="$route.path !== '/console/profile'"
                class="btn mt-3 px-4 float-right text-right btn-success btn-md rounded-pill"
                to="/console/profile"
              >
                Lengkapi Data
              </nuxt-link>
              <b-button
                v-else
                variant="success"
                pill
                class="btn mt-3 px-4 float-right text-right"
                size="md"
                @click="setShowModal"
              >
                Lengkapi Data
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalTelegram"
        centered
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="text-center">
          <img src="@/assets/icon/icon-telegram-notif.png" alt="" class="mt-4">
          <h4 class="my-3 font-rubik-medium">
            Aktifkan Notifikasi Telegram
          </h4>
          <p>Dapatkan pemberitahuan terkait jadwal konsultasi secara otomatis melalui Telegram dengan menghubungkan akun Telegram Anda</p>
          <div class="mx-4 mt-4 mb-2">
            <b-button variant="success" pill class="w-100 mb-3 position-relative" @click="openTelegram">
              Aktifkan Sekarang
              <svg
                width="36"
                height="23"
                viewBox="0 0 36 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="position-absolute right-3 top-3"
              >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0991211 20.3854C0.0991211 20.9562 0.299204 21.5287 0.701871 21.9621C1.5072 22.8337 2.81108 22.8337 3.61558 21.9621L13.3855 11.3904L3.61558 0.817891C2.81108 -0.0512761 1.5072 -0.0512761 0.701871 0.817891C-0.101796 1.68872 -0.101796 3.09956 0.701871 3.97039L7.55971 11.3904L0.701871 18.8096C0.299204 19.2446 0.0991211 19.8162 0.0991211 20.3854Z" fill="white" fill-opacity="0.1" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0605 20.3854C11.0605 20.9562 11.2606 21.5287 11.6633 21.9621C12.4686 22.8337 13.7725 22.8337 14.577 21.9621L24.3469 11.3904L14.577 0.817891C13.7725 -0.0512761 12.4686 -0.0512761 11.6633 0.817891C10.8596 1.68872 10.8596 3.09956 11.6633 3.97039L18.5211 11.3904L11.6633 18.8096C11.2606 19.2446 11.0605 19.8162 11.0605 20.3854Z" fill="white" fill-opacity="0.3" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6904 20.3854C21.6904 20.9562 21.8905 21.5287 22.2932 21.9621C23.0985 22.8337 24.4024 22.8337 25.2069 21.9621L34.9768 11.3904L25.2069 0.817891C24.4024 -0.0512761 23.0985 -0.0512761 22.2932 0.817891C21.4895 1.68872 21.4895 3.09956 22.2932 3.97039L29.151 11.3904L22.2932 18.8096C21.8905 19.2446 21.6904 19.8162 21.6904 20.3854Z" fill="white" />
              </svg>
            </b-button>
            <b-button
              variant="warning-2"
              pill
              class="text-white w-100 mr-md-2 mb-2 mb-md-0"
              @click="closeModalTelegram"
            >
              Aktifkan Nanti
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalConnectionDisconnect"
        centered
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="p-4">
          <div class="text-center" style="font-size: 17pt">
            <strong>Koneksi Terputus</strong>
          </div>
          <div class="text-center mt-2" style="font-size: 14pt">
            Silakan cek koneksi Anda dan pastikan stabil. Silakan refresh untuk mencoba ulang
          </div>
          <div class="text-center mt-4">
            <b-button
              variant="primary"
              style="background: #1A5CAC;border-radius: 32px"
              class="px-4"
              @click="reloadPage"
            >
              REFRESH
            </b-button>
          </div>
        </div>
      </b-modal>
    </section>
  </div>
</template>
<script>
import createPin from '@/components/modal-dialog/CreatePin.vue'
import Tutorial from '@/components/Tutorial'
import modalImage from '@/components/ModalImage'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { DOCTOR_TYPE_PSYCHOLOGIST } from '../constants'
let DetectRTC

export default {
  name: 'LayoutConsole',
  components: { createPin, Tutorial, modalImage },
  directives: {
    'click-outside': {
      bind: function bind (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = '[Vue-click-outside:] provided expression \'' + binding.expression + '\' is not a function, but has to be'
          if (compName) {
            warn += 'Found in component \'' + compName + '\''
          }

          throw new Error(warn)
        }
        // Define Handler and cache it on the element
        const handler = function handler (e) {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function unbind (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  middleware: ['auth'],

  data () {
    const self = this
    return {
      desktop: false,
      tab: false,
      mobile: false,
      timerContinuousScheduleCheck: null,
      loadingUpdate: false,
      choosen: 'calendar',
      mouseDashboard: false,
      mouseConsult: false,
      mouseCalendar: false,
      mouseHistory: false,
      errorImage: false,
      notifications: [],
      notificationsRead: [],
      notificationsUnRead: [],
      notifPage: 1,
      tabsNotif: '',
      lastNotifPage: 1,
      searchNotif: '',
      notifPopover: false,
      notifTelegram: false,
      totalUnredNotifications: 0,
      hasNewNotification: false,
      shouldCheckNotification: false,
      stopScroll: false,
      badgeDotActive: false,
      dataActive: null,
      setIntervalNotification: null,
      notificationRequesting: false,
      navbar: false,
      listNavbar: [
        {
          path: '/console/dashboard',
          title: 'Dashboard',
          imageNotActive: require('~/assets/img/dashboard-inactive.png'),
          imageActive: require('~/assets/img/dashboard-active.png'),
          active: true,
          disabled: self.$store.state.user.auth.role === 'admin'
        },
        {
          path: process.env.BASE_SPECIALIST_URL + 'consult',
          title: 'Konsultasi',
          imageNotActive: require('~/assets/img/konsultasi-inactive.png'),
          imageActive: require('~/assets/img/konsultasi-active.png'),
          active: false,
          disabled: self.$store.state.user.auth.role === 'admin',
          external: true
        },
        {
          path: '/console/consultation-history',
          title: 'Riwayat',
          imageNotActive: require('~/assets/img/riwayat-inactive.png'),
          imageActive: require('~/assets/img/riwayat-active.png'),
          active: false,
          disabled: self.$store.state.user.auth.role === 'admin'
        },
        {
          path: '/console/calendar',
          title: 'Kalender',
          imageNotActive: require('~/assets/img/kalender-inactive.png'),
          imageActive: require('~/assets/img/kalender-active.png'),
          active: false,
          disabled: false
        },
        {
          path: '/console/finance',
          title: 'Keuangan',
          imageNotActive: require('~/assets/icon/icon-nav-finance.svg'),
          imageActive: require('~/assets/icon/icon-nav-finance-white.svg'),
          active: false,
          disabled: self.$store.state.user.auth.role === 'admin'
        },
        {
          path: '/console/report',
          title: 'Laporan',
          imageNotActive: require('~/assets/icon/icon-nav-report.svg'),
          imageActive: require('~/assets/icon/icon-nav-report-white.svg'),
          active: false,
          disabled: self.$store.state.user.auth.role === 'admin'
        }
      ],
      counterIntervalObject: null,
      otp: '',
      timerSeconds: '',
      timerMinutes: '',
      blocked: false,
      loadingVerify: false,
      errorOTP: false,
      connectionError: false,
      isMobile: false,
      widthScreen: 769,
      isChromeIOS: false,
      isEmit5Minutes: false,
      isEmit3Minutes: false,
      ram: false,
      osName: false,
      osVersion: false,
      isFirefox: false,
      isChrome: false,
      isAndroid: false,
      isIphone: false,
      isIpad: false,
      isEdge: false,
      isOpera: false,
      isSamsungBrowser: false,
      isSafari: false,
      isBrave: false,
      countNotifications: 0,
      isGoToSchedule: false
    }
  },
  computed: {
    ...mapGetters({
      userData: 'user/getAuthUserData',
      isProfileCompleted: 'profile/getStatusProfile',
      isShowModal: 'profile/getStatusModal'
    }),
    guideModal: {
      get () {
        return this.$store.state.guideModal
      },
      set (value) {
        this.$store.commit('SET_OPEN_GUIDE_MODAL', value)
      }
    },

    scheduleTimer () {
      return this.$store.state.consultation.scheduleTimer.epochTimer
    },

    expiredConsultationTimer () {
      return this.$store.state.consultation.expiredConsultationTimer.epochTimer
    },

    filteredListNavbar () {
      const data = []

      if (this.listNavbar) {
        this.listNavbar.forEach((navbar) => {
          if (!navbar.disabled) {
            data.push(navbar)
          }
        })
      }

      return data
    },
    newFaq () {
      return this.$store.state.user.auth.userData.HasNewFaq === 1
    },
    newTnc () {
      return this.$store.state.user.auth.userData.HasNewTnc === 1
    },
    newVideoTutorial () {
      return this.$store.state.user.auth.userData.HasNewVideoTutorial === 1
    },
    connectedToTelegram () {
      return this.$store.state.user.auth.userData?.TelegramAccount?.Connected
    },
    isPsychologist () {
      return this.$store.state.user.auth.userData.DoctorType === DOCTOR_TYPE_PSYCHOLOGIST
    }
  },
  watch: {
    $route () {
      this.checkCurrentRoute()

      if (this.$route.path === '/console/consultation-history') {
        this.choosen = 'history'
      } else if (this.$route.path === '/console') {
        this.choosen = 'consult'
      } else if (this.$route.path === '/console/calendar') {
        this.choosen = 'calendar'
      } else if (this.$route.path === '/console/dashboard') {
        this.choosen = 'dashboard'
      } else if (this.$route.path === '/console/finance') {
        this.choosen = 'finance'
      } else if (this.$route.path === '/console/report') {
        this.choosen = 'report'
      }
    },
    searchNotif () {
      if (this.searchNotif !== '') {
        this.searching()
      }
    },
    userData: {
      handler (value) {
        const dataDoctor = (value && value.Doctor) ? value.Doctor : value
        if (dataDoctor) {
          if (this.$route.path !== '/console/calendar') {
            if (this.$route.path === '/console/dashboard' || this.$route.path === '/console/consultation-history' || this.$route.path === '/console/finance' || this.$route.path === '/console/report') {
              if (!this.userData.Changes && (!dataDoctor.AccountType || !dataDoctor.AccountResidence || !dataDoctor.BankID || !dataDoctor.Bank || !dataDoctor.University || !dataDoctor.YearGraduated)) {
                this.$bvModal.show('modalForceCompleteProfile')
              } else if (this.userData.Changes && !dataDoctor.BankID && !dataDoctor.Bank) {
                this.$bvModal.show('modalForceCompleteProfile')
              } else {
                this.$bvModal.hide('modalForceCompleteProfile')
              }
            } else {
              this.$bvModal.hide('modalForceCompleteProfile')
            }
          }
        }
      },
      deep: true
    },
    '$store.state.consultation.inConsultation' (val) {
      if (val) {
        this.clearNotificationInterval()
        this.isEmit5Minutes = false
        this.isEmit3Minutes = false
      } else {
        this.startNotificationInterval()
      }
    },
    scheduleTimer (val) {
      const inConsultation = this.$store.state.consultation.inConsultation
      if (val <= 60000 * 5 && !this.isEmit5Minutes && !inConsultation) {
        this.emitCurrentSchedule('globalSocket/setDoctorTimerBeforeConsultation')
        this.isEmit5Minutes = true
      }
      if (val <= 60000 * 3 && !this.isEmit3Minutes && !inConsultation) {
        this.emitCurrentSchedule('globalSocket/setDoctorTimerAfterConsultation')
        this.isEmit3Minutes = true
      }
    },
    countNotifications (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchNotifications(this.notifPage, false)
      }
    }
  },
  created () {
    if (this.$route.path === '/console/consultation-history') {
      this.choosen = 'history'
    } else if (this.$route.path === '/console') {
      this.choosen = 'consult'
    } else if (this.$route.path === '/console/calendar') {
      this.choosen = 'calendar'
    } else if (this.$route.path === '/console/dashboard') {
      this.choosen = 'dashboard'
    } else if (this.$route.path === '/console/finance') {
      this.choosen = 'finance'
    } else if (this.$route.path === '/console/report') {
      this.choosen = 'report'
    }
    if (process.client && navigator.userAgent.match('CriOS')) {
      this.isChromeIOS = true
    }
  },
  beforeMount () {
    this.widthScreen = window.innerWidth
  },
  mounted () {
    window.addEventListener('resize', this.resizeScreen)
    this.$store.commit('RTC/SET_RAM_SIZE', navigator.deviceMemory)
    this.$nextTick(() => {
      this.$nuxt.$loading.start()
      setTimeout(() => this.$nuxt.$loading.finish(), 1000)
    })
    this.$store.dispatch('user/getUserInfo')
      .then((res) => {
        // this.connectGlobalSocket()
        this.globalSocketChat()
        this.checkVerifiedEmail(res)
      }).catch((err) => {
        this.$router.push('/auth/login')
        throw new Error(err)
      })
    const ua = navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      if (window.screen.width < window.screen.height) {
        this.tab = true
      } else {
        this.desktop = true
      }
    } else if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      this.mobile = true
    } else {
      this.desktop = true
    }

    this.checkCurrentRoute()
    if (!this.tabsNotif) {
      this.tabsNotif = 'unread'
    }
    if (!this.connectedToTelegram && !localStorage.getItem('modalTelegram') && this.$store.state.user.auth.role !== 'admin') {
      this.openModalTelegram()
    } else {
      setTimeout(() => {
        this.notifTelegram = true
      }, 500)
    }

    // TODO temporary disabled notification for admin
    if (this.$store.state.user.auth.role === 'doctor') {
      this.$nuxt.$on('stopCheckingScheduleOtherPage', () => {
        this.stopCheckingSchedule()
      })
    }
    this.startNotificationInterval()
    DetectRTC = require('detectrtc')
    this.checkBrowserCompability()
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeScreen)
    this.isGoToSchedule = false
  },
  methods: {
    resizeScreen (e) {
      this.widthScreen = window.innerWidth
    },
    reloadPage () {
      if (process.client) {
        window.location.reload()
      }
    },
    handleOpenTitle (type, title) {
      this.$refs[type].$el.setAttribute('title', title)
    },
    openModalTelegram () {
      this.$bvModal.show('modalTelegram')
    },
    openTelegram () {
      this.$router.push('/console/telegram')
      this.closeModalTelegram()
    },
    closeModalTelegram () {
      this.$bvModal.hide('modalTelegram')
      localStorage.setItem('modalTelegram', 'not-active')
      setTimeout(() => {
        this.notifTelegram = true
      }, 100)
    },
    startNotificationInterval () {
      if (this.$store.state.user.auth.role === 'doctor') {
        if (this.notificationRequesting) { return }
        this.setIntervalNotification = setInterval(() => {
          this.fetchCountNotifications()
        }, 10 * 1000)
      }
    },
    clearNotificationInterval () {
      clearInterval(this.setIntervalNotification)
    },

    makeid (length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    emitCurrentSchedule (action) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.$store.state.globalSocket.isAuthorized) {
            if (this.$store.state.calendar.currentSchedule &&
              this.$store.state.calendar.currentSchedule.Appointment &&
              this.$store.state.calendar.currentSchedule.Appointment.PublicID
            ) {
              const now = new Date().getTime()
              const payload = {
                appointmentID: this.$store.state.calendar.currentSchedule.Appointment.PublicID,
                clientTimestamp: parseInt(now / 1000)
              }
              this.$store.dispatch(action, payload)
              resolve(true)
            } else {
              this.emitCurrentSchedule(action)
            }
          } else {
            this.emitCurrentSchedule(action)
          }
        }, 250)
      })
    },
    globalSocketChat () {
      this.$store.commit('globalSocket/SET_SOCKET_PERSIST_NAME_CHAT', this.makeid(10))
      this.socket = this.$nuxtSocket({
        name: 'globalChat',
        channel: '/',
        persist: this.$store.state.globalSocket.socketPersistNameChat,
        url: process.env.SOCKET_CHAT_URL,
        withCredentials: false
      })

      this.socket.on('connect', () => {
        this.$store.commit('globalSocket/SET_CONNECT_SOCKET_CHAT', true)
        this.$store.dispatch('globalSocket/authorizationSocketChat')
        this.socket.on('broadcast', (msg) => {
          this.$nuxt.$emit('broadcast', msg)
        })
        this.socket.on('done', (ticket) => {
          this.$nuxt.$emit('done', ticket)
        })
      })
    },

    async connectGlobalSocket () {
      this.$store.commit('globalSocket/SET_SOCKET_PERSIST_NAME', this.makeid(10))

      this.globalSocket = await this.$nuxtSocket({
        name: 'global',
        channel: '/',
        persist: this.$store.state.globalSocket.socketPersistName,
        url: process.env.GLOBAL_SOCKET_URL
        // reconnection: false,
      })

      this.globalSocket.on('connect', () => {
        this.$store.dispatch('globalSocket/authorization')
        this.$store.commit('globalSocket/CONNECT', true)
        console.log('GLOBAL SOCKET CONNECTED')
      })

      this.globalSocket.on('error', (data) => {
        console.log('GLOBAL SOCKET ERROR')
        this.$sentry.captureException(new Error(`[SOCKET_ERROR] ${data}`))
      })

      this.globalSocket.on('reconnect', (data) => {
        console.log('GLOBAL SOCKET RECONNECT', data)
        this.$store.commit('globalSocket/SET_IS_DOCTOR_RECONNECT', true)
      })

      this.globalSocket.on('Reconnect', (data) => {
        console.log('DOCTOR RECONNECT')
        this.$store.dispatch('globalSocket/log', { data: 'DOCTOR RECONNECT' })
        const doctorReconnect = this.$store.state.globalSocket.isDoctorReconnect
        if (!doctorReconnect) {
          if (this.$store.state.calendar.currentSchedule && this.$store.state.calendar.currentSchedule.Appointment &&
            this.$store.state.calendar.currentSchedule.Appointment.ConsultationStatus === 'IN_SESSION' && this.$store.state.consultation.callStatus === 'IN_CALL') {
            setTimeout(() => {
              console.log('DOCTOR RECONNECT timeout')
              this.$store.dispatch('globalSocket/log', { data: 'DOCTOR RECONNECT timeout' })
              this.$bvModal.show('modalSomethingWrong')
            }, 30 * 1000)
          }
          return
        }
        this.$nuxt.$emit('doctorReconnect')
      })

      this.globalSocket.on('connect_error', (data) => {
        console.log('GLOBAL SOCKET CONNECT ERROR', data)
        const globalSocketConnect = this.$store.state.globalSocket.isSocketConnected
        const inConsultation = this.$store.state.consultation.inConsultation
        if (!this.connectionError) { return }
        if (this.connectionError && !globalSocketConnect && !inConsultation && this.$route.name === 'console') {
          this.$swal({
            title: 'Mencoba terhubung dengan server...',
            position: 'top',
            showConfirmButton: false,
            customClass: {
              container: 'toastDisconnect'
            },
            timer: 3000,
            toast: true
          })
          this.connectionError = false
        }
        this.$store.dispatch('globalSocket/log', {
          data: 'GLOBAL_SOCKET_CONNECT_ERROR',
          status: 'ERROR'
        })
        this.$sentry.captureException(new Error(`[GLOBAL_SOCKET_CONNECT_ERROR] ${data}`))
      })

      this.globalSocket.on('disconnect', (data) => {
        console.log('GLOBAL SOCKET DISCONNECTED', data)
        this.connectionError = true
        this.$store.commit('globalSocket/CONNECT', false)
        this.$store.dispatch('globalSocket/log', { data: 'GLOBAL_SOCKET_DISCONNECT' })
      })
    },
    nextPhone () {
      if (!this.$store.state.user.auth.userData.HasVerifiedPhone) {
        if (this.$store.state.user.auth && this.$store.state.user.auth.userData && this.$store.state.user.auth.userData.Changes) {
          this.$bvModal.show('modalPhone')
        }
      }
    },
    nextEmail () {
      this.$store.dispatch('user/sendEmailUpdated')
        .then((response) => {
          this.$bvModal.hide('modalEmail')
          this.$bvModal.show('modalEmailSent')
        })
        .catch((error) => {
          this.$bvModal.hide('modalEmail')
          this.$bvModal.show('modalEmailSent')
          throw new Error(error)
        })
    },
    checkVerifiedEmail (response) {
      if (!response.HasVerifiedPhone) {
        if (this.$store.state.user.auth && this.$store.state.user.auth.userData && this.$store.state.user.auth.userData.Changes) {
          if (this.$route.name !== 'console-profile') {
            this.$bvModal.show('modalPhone')
          }
        }
      }
    },
    sendOtp () {
      this.$router.push('/console/profile')
    },
    verifyOTP () {
      this.loadingVerify = true
      const self = this
      if (!this.otp) { return }
      this.$store
        .dispatch('user/sendOTPUpdated', {
          sendUrl: 'doctor/verify/otp/updated',
          sendBody: {
            OTP: this.otp
          }
        })
        .then((res) => {
          this.loadingVerify = false
          this.$bvModal.hide('modalOTP1')
          self.$swal({
            title: 'Nomor Handphone Telah Diverifikasi',
            icon: 'success'
          })
        })
        .catch((error) => {
          const data = error.response.data
          if (data && data.Message && data.Message === 'RESOURCE_NOT_FOUND') {
            this.errorOTP = true
          }
          this.loadingVerify = false
        })
    },
    handleOnComplete (value) {
      this.otp = value
    },
    addStyle (index) {
      this.$refs.otpInput.$el.childNodes[index].childNodes[0].style.cssText = 'border-bottom: 5px solid #00C300 !important;'
    },
    deleteStyle (index) {
      this.$refs.otpInput.$el.childNodes[index].childNodes[0].style.cssText = 'border-bottom: 5px solid rgba(0, 0, 0, 0.3) !important;'
    },
    async handleOnChange (value) {
      await this.$refs.otpInput.$el.childNodes[1].childNodes[0].value
      await this.$refs.otpInput.$el.childNodes[1].childNodes[0].value ? this.addStyle(1) : this.deleteStyle(1)
      await this.$refs.otpInput.$el.childNodes[2].childNodes[0].value ? this.addStyle(2) : this.deleteStyle(2)
      await this.$refs.otpInput.$el.childNodes[3].childNodes[0].value ? this.addStyle(3) : this.deleteStyle(3)
      await this.$refs.otpInput.$el.childNodes[4].childNodes[0].value ? this.addStyle(4) : this.deleteStyle(4)
    },
    setTimer (base_time) {
      const self = this
      let curr = base_time
      let minutes = Math.floor((base_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((base_time % (1000 * 60)) / 1000)

      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }

      if (self.counterIntervalObject) { clearInterval(self.counterIntervalObject) }

      this.timerSeconds = seconds
      this.timerMinutes = minutes

      self.counterIntervalObject = setInterval(function () {
        curr -= 1000
        minutes = Math.floor((curr % (1000 * 60 * 60)) / (1000 * 60))
        seconds = Math.floor((curr % (1000 * 60)) / 1000)
        if (minutes < 10) { minutes = '0' + minutes }
        if (seconds < 10) { seconds = '0' + seconds }
        self.timerSeconds = seconds
        self.timerMinutes = minutes

        if (curr < 0) {
          minutes = Math.floor((base_time % (1000 * 60 * 60)) / (1000 * 60))
          seconds = Math.floor((base_time % (1000 * 60)) / 1000)
          if (minutes < 10) { minutes = '0' + minutes }
          if (seconds < 10) { seconds = '0' + seconds }
          self.timerSeconds = seconds
          self.timerMinutes = minutes
          clearInterval(self.counterIntervalObject)

          self.counterIntervalObject = null
        }
      }, 1000)
    },
    closeNavbar (openNavbar = false) {
      if (openNavbar) { return }
      this.navbar = false
    },
    conditionalText (obj) {
      switch (obj.Type) {
        case 'REFUND' : return `<b>${obj.Patient}</b> telah mengajukan refund untuk konsultasi <b>#${obj.RelationID}</b>`
        case 'UNFINISHED_SUMMARY' : return `Anda gagal menyelesaikan rangkuman konsultasi dengan <b>${obj.Patient}</b>`
        case 'DOCTOR_NO_ANSWER': return `Janji konsultasi Anda dengan <b>${obj.Patient}</b> terlewati`
        case 'BOTH_NO_ANSWER': return `Janji konsultasi Anda dengan <b>${obj.Patient}</b> terlewati`
        case 'CLINIC_INVITATION' : return `<b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b> mengajak Anda untuk bergabung bersama YesDok ${obj.Clinic ? (obj.Clinic && obj.Clinic.Type === 'CLINIC' ? 'Klinik' : 'Hospital') : ''}`
        case 'CLINIC_TERMINATED' : return `<b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b> sudah tidak bekerjasama dengan Anda dikarenakan akun ${obj.Clinic ? (obj.Clinic && obj.Clinic.Type === 'HOSPITAL' ? 'Rumah Sakit' : 'Klinik') : ''} tersebut sudah <b>tidak aktif.</b> Jadwal dan akun Anda akan secara otomatis berubah menjadi dokter <b>YesDok Network</b>`
        case 'CLINIC_REQUEST_SCHEDULE' : return `<b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b> mengundang Anda di jadwal <b>${obj.Clinic && obj.Clinic.Start ? `${this.$moment((obj.Clinic && obj.Clinic.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic && obj.Clinic.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        case 'CLINIC_REJECTED_SCHEDULED' : return `<b>${(obj.Clinic && obj.Clinic.Clinic.ClinicName) || '-'}</b> menolak permintaan jadwal anda pada<br><b>${obj.Clinic && obj.Clinic.Start ? `${this.$moment((obj.Clinic && obj.Clinic.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic && obj.Clinic.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        case 'CLINIC_APPROVED_SCHEDULED' : return `<b>${(obj.Clinic && obj.Clinic.Clinic.ClinicName) || '-'}</b> menerima permintaan jadwal anda pada<br><b>${obj.Clinic && obj.Clinic.Start ? `${this.$moment((obj.Clinic && obj.Clinic.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic && obj.Clinic.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        case 'UPDATE_PROFILE_REJECTED' : return 'Edit profile dokter Anda <b>gagal diverifikasi</b>, silakan periksa email untuk update data Anda'
        case 'UPDATE_PROFILE_APPROVED' : return 'Pengajuan perubahan data Anda telah disetujui'
        case 'PATIENT_BOOK_SCHEDULE' : return `<b>${obj.Patient || '-'}</b> telah membuat janji konsultasi untuk <b>${obj.Clinic && obj.Clinic.Start ? `${this.$moment((obj.Clinic && obj.Clinic.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic && obj.Clinic.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        case 'CLINIC_SUSPENDED' : return `<b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b> dalam masa ditangguhkan, sementara Anda tidak bisa berpraktik dengan <b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b>`
        case 'CLINIC_CANCEL_INVITE_DOCTOR' : return `<b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b> telah membatalkan undangan Anda pada <b>${obj.Timestamp ? `${this.$moment((obj.Timestamp) * 1000).format('dddd, DD MMMM YYYY HH:mm')}` : '-'}</b>`
        case 'CLINIC_DELETE_SCHEDULE' : return `<b>${(obj.Clinic && obj.Clinic.ClinicName) || '-'}</b> telah menghapus jadwal praktik untuk <b>${obj.Clinic && obj.Clinic.Start ? `${this.$moment((obj.Clinic && obj.Clinic.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic && obj.Clinic.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        case 'PATIENT_REPORT_CONSULTATION' : return `<b>${obj.Patient || '-'}</b> telah membuat laporan masalah untuk id konsultasi <b>${(obj.Clinic && obj.Clinic.PracticingID) || '-'}</b>`
        case 'CLINIC_TAGGING_DOCTOR' : return `<b>${(obj.Clinic && obj.Clinic.Clinic && obj.Clinic.Clinic.ClinicName) || '-'}</b> menandai Anda di jadwal <b>${obj.Clinic && obj.Clinic.CalendarOnlineDoctor && obj.Clinic.CalendarOnlineDoctor.Start ? `${this.$moment((obj.Clinic.CalendarOnlineDoctor.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic.CalendarOnlineDoctor.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        case 'PATIENT_BOOK_RESCHEDULE' : return `<b>${obj.Patient || '-'}</b> telah mengajukan <b>jadwal ulang</b> di jadwal Anda: <b>${obj.Clinic && obj.Clinic.Start ? `${this.$moment((obj.Clinic && obj.Clinic.Start) * 1000).format('dddd, DD MMMM YYYY HH:mm')} - ${this.$moment((obj.Clinic && obj.Clinic.End) * 1000).format('HH:mm')} WIB` : '-'}</b>`
        default: return null
      }
    },
    notificationText (data) {
      data.map((obj) => {
        obj.active = !obj.Read
        obj.text = this.conditionalText(obj)
        if (obj.text) {
          if (obj.active) {
            if (!_.find(this.notificationsUnRead, ['ID', obj.ID])) {
              this.notificationsUnRead.push(obj)
              this.notificationsUnRead = _.orderBy(this.notificationsUnRead, ['ID'], ['desc'])
            }
          } else if (!_.find(this.notificationsRead, ['ID', obj.ID])) {
            this.notificationsRead.push(obj)
            this.notificationsRead = _.orderBy(this.notificationsRead, ['ID'], ['desc'])
          }
        }
      })
      if (this.shouldCheckNotification && this.notificationsUnRead.length > this.totalUnredNotifications) {
        // has new notification
        this.$store.commit('calendar/SET_HAS_NEW_NOTIFICATION', true)
        this.totalUnredNotifications = this.notificationsUnRead.length
      } else {
        if (!this.shouldCheckNotification) {
          // set total unread at first time
          this.totalUnredNotifications = this.notificationsUnRead.length
        }
        this.shouldCheckNotification = true
      }
      this.notifications = data
    },
    fetchCountNotifications () {
      this.$store.dispatch('getNotifications', 'Count=1')
        .then((res) => {
          this.countNotifications = res.data.Data
        }).catch((err) => {
          this.clearNotificationInterval()
          throw new Error(err)
        })
    },
    fetchNotifications (page, popover = false) {
      if (this.notificationRequesting) { return }
      this.notificationRequesting = true

      let params = `Page=${page}`
      if (this.searchNotif !== '') {
        params += `&Search=${this.searchNotif}`
      }
      this.$store.dispatch('getNotifications', params)
        .then((res) => {
          const data = res.data.Data
          this.$store.commit('SET_NOTIFICATION', data)
          if (data && data.length !== 0) {
            this.notificationText(data)
          }
          this.dataActive = _.filter(data, { active: true })
          if (data.length === 0) {
            this.stopScroll = data.length === 0
          } else if (this.dataActive && this.dataActive.length > 0) {
            if (popover) {
              if (!this.tab) {
                this.notifPopover = true
              }
            }
            this.badgeDotActive = true
          } else {
            // this.tabsNotif = 'read'
            this.badgeDotActive = false
          }
          this.notificationRequesting = false
        }).catch((err) => {
          clearInterval(this.setIntervalNotification)
          this.notificationRequesting = false
          throw new Error(err)
        })
    },
    searching: _.debounce(function () {
      this.notificationsRead = []
      this.notificationsUnRead = []
      this.notifications = []
      this.stopScroll = false
      this.notifPage = 1
      this.fetchNotifications(this.notifPage)
      this.$tracker({
        action: 'txt_search_notif',
        category: 'notification',
        label: this.searchNotif
      })
    }, 500),
    scrolled ($event) {
      if (!this.stopScroll && $event.target.offsetHeight + $event.target.scrollTop >= $event.target.scrollHeight) {
        this.fetchNotifications(this.notifPage += 1)
      }
      if ($event.target.scrollTop === 0) {
        this.notifPage = 1
      }
    },
    goToConsultation (id, relationID, toConsole) {
      this.$store.dispatch('updateNotification', id)
        .then((res) => {
          if (toConsole) {
            this.$router.push('/console')
            this.$store.commit('SET_RELATION_ID', relationID)
            this.notifPopover = false
          } else {
            this.totalUnredNotifications -= 1
            this.tabsNotif = 'read'
          }
          this.notifications = []
          this.fetchNotifications(this.notifPage)
        }).catch((err) => {
          throw new Error(err)
        })
      this.notificationsRead = []
      this.notificationsUnRead = []
      this.$tracker({
        action: 'cta_view_notif_detail',
        category: 'notification'
      })
    },
    goToProfile () {
      this.$store.commit('profile/SET_CLINIC_INVITATION', true)
      this.$router.push({ name: 'console-profile' })
      this.notifPopover = false
    },
    checkYesterday (date) {
      return this.$moment(new Date(parseFloat(date + '000'))).isBefore(new Date(), 'day')
    },
    handleMouse (event) {
      if (/Dashboard/.test(event.target.textContent)) {
        if (event.type === 'mouseover') {
          this.mouseDashboard = true
        } else {
          this.mouseDashboard = false
        }
      } else if (/Riwayat/.test(event.target.textContent)) {
        if (event.type === 'mouseover') {
          this.mouseHistory = true
        } else {
          this.mouseHistory = false
        }
      } else if (/Konsultasi/.test(event.target.textContent)) {
        if (event.type === 'mouseover') {
          this.mouseConsult = true
        } else {
          this.mouseConsult = false
        }
      } else if (/Kalender/.test(event.target.textContent)) {
        if (event.type === 'mouseover') {
          this.mouseCalendar = true
        } else {
          this.mouseCalendar = false
        }
      } else if (/Keuangan/.test(event.target.textContent)) {
        if (event.type === 'mouseover') {
          this.mouseCalendar = true
        } else {
          this.mouseCalendar = false
        }
      }
    },
    handleSideBar (menu) {
      if (menu === 'calendar') {
        this.choosen = 'calendar'
      } else if (menu === 'dashboard') {
        this.choosen = 'dashboard'
      } else if (menu === 'consult') {
        this.choosen = 'consult'
      } else if (menu === 'history') {
        this.choosen = 'history'
      } else if (menu === 'finance') {
        this.choosen = 'finance'
      } else if (menu === 'report') {
        this.choosen = 'report'
      }
    },
    handleErrorImage () {
      this.errorImage = true
    },
    logout () {
      if (this.$store.state.user.auth.role !== 'admin') {
        this.$store.dispatch('user/logout')
          .then(() => {
            this.$router.push('/auth/login')
          })
      } else {
        this.$store.dispatch('user/resetDataUser')
        this.$router.push('/auth/login')
      }
      this.$tracker({
        action: 'cta_nav_sign_out',
        category: 'navbar'
      })
    },

    navigateCalendar (mode) {
      if (!this.isGoToSchedule) {
        mode = mode || 'next'
        const startValue = this.$moment()
        const endValue = this.$moment()

        if (mode === 'prev') {
          this.$store.commit('calendar/NAVIGATE', {
            key: 'weekPosition',
            value: this.$store.state.calendar.navigator.weekPosition - 1
          })
        } else if (mode === 'next') {
          this.$store.commit('calendar/NAVIGATE', {
            key: 'weekPosition',
            value: this.$store.state.calendar.navigator.weekPosition + 1
          })
        }

        startValue.add(this.$store.state.calendar.navigator.weekPosition, 'weeks')
        endValue.add(this.$store.state.calendar.navigator.weekPosition, 'weeks')

        this.$store.commit('calendar/NAVIGATE', {
          key: 'start',
          value: startValue.startOf('week').format('YYYY-MM-DD')
        })

        this.$store.commit('calendar/NAVIGATE', {
          key: 'end',
          value: endValue.endOf('week').format('YYYY-MM-DD')
        })

        this.$nuxt.$emit(
          'navigateCalendar',
          this.$store.state.calendar.navigator.start,
          this.$store.state.calendar.navigator.end
        )
      }
    },

    checkSchedule () {
      const self = this

      return new Promise((resolve, reject) => {
        self.$store
          .dispatch('calendar/getCurrentSchedule')
          .then((res) => {
            if (self.scheduleTimer && self.scheduleTimer <= 60000) { self.$router.push('/console') }

            if (self.expiredConsultationTimer && self.expiredConsultationTimer <= 60000 * 3) {
              self.$router.push('/console')
            }

            resolve(res)
          })
          .catch((error) => {
            clearInterval(this.timerContinuousScheduleCheck)
            reject(error)
          })
      })
    },

    startCheckingSchedule () {
      if (this.$store.state.user.auth.role === 'admin') { return }

      this.checkSchedule()

      this.timerContinuousScheduleCheck = setInterval(() => {
        this.checkSchedule()
      }, 1000 * 15)
    },

    stopCheckingSchedule () {
      console.log('stop checking schedule on other page')
      clearInterval(this.timerContinuousScheduleCheck)
    },

    checkCurrentRoute () {
      if (this.$route.name !== 'console') {
        // do checking
        this.startCheckingSchedule()
      } else {
        this.stopCheckingSchedule()
      }
    },
    doPreviewImage (val) {
      const payload = {
        modal: val || false,
        url: ''
      }
      this.$store.dispatch('consultation/setPreviewImage', payload)
      this.$tracker({
        action: 'cta_modal_hide_preview_image',
        category: 'consultation_video'
      })
    },
    handleLink (location) {
      const self = this
      const path = process.env.BASE_BOOKING_URL
      const doctorData = self.$store.state.user.auth.role === 'admin' ? self.$store.state.user.auth.userData.Doctor : self.$store.state.user.auth.userData

      if (self.$store.state.user.auth.userData) {
        this.shareText = 'Booking konsultasi video dengan ' + doctorData.Fullname + ' (' + doctorData.DoctorTypeLang.ID + ')'
      }

      const letter = doctorData.Fullname.split('')
      const lastIndex = letter.length - 1

      if (letter[lastIndex] === ' ') {
        letter.splice(lastIndex, 1)
      } else if (letter[0] === ' ') {
        letter.splice(0, 1)
      }
      const joinedLetter = letter.join('')

      if (location === 'wa') {
        window.open(`https://api.whatsapp.com/send?text=*${joinedLetter}*%0A${doctorData.DoctorTypeLang.ID}%0A%0AKonsultasi Gampang!%0ALihat jadwal konsultasi online:%0A${path}${doctorData.PublicID}`, '_blank')
      } else if (location === 'mail') {
        window.open(`mailto:?Subject=${self.shareText}&Body=Read more at ${path}${doctorData.PublicID}`, '_blank')
      } else if (location === 'fb') {
        window.open(`http://www.facebook.com/sharer.php?u=${path}${doctorData.PublicID}`, '_blank')
      } else if (location === 'in') {
        window.open(`http://www.linkedin.com/shareArticle?mini=true&url=${path}${doctorData.PublicID}`, '_blank')
      } else if (location === 'tw') {
        window.open(`https://twitter.com/share?url=${path}${doctorData.PublicID}&text=${self.shareText}%0A%0DCek disini`, '_blank')
      } else if (location === 'copy') {
        const str = `${path}${doctorData.PublicID}`
        const el = document.createElement('input')
        el.value = str
        document.body.appendChild(el)
        el.select()
        try {
          const successful = document.execCommand('copy')
          if (successful) {
            this.$swal({
              text: 'Salin tautan berhasil!',
              timer: 2000,
              icon: 'success'
            })
          } else {
            this.$swal({
              text: 'Salin tautan gagal!',
              timer: 2000,
              icon: 'error'
            })
          }
        } catch (err) {
          this.$swal({
            text: 'Salin tautan gagal!',
            timer: 2000,
            icon: 'error'
          })
        }

        document.body.removeChild(el)
      }

      let label = ''
      switch (location) {
        case 'wa': label = 'whatsapp'
          break
        case 'mail': label = 'email'
          break
        case 'fb': label = 'facebook'
          break
        case 'in': label = 'linkedin'
          break
        case 'tw': label = 'twitter'
          break
        case 'copy': label = 'copy_link'
          break
      }
      self.$tracker({
        action: 'cta_nav_share',
        category: 'navbar',
        label
      })
    },
    setShowModal () {
      this.$bvModal.hide('modalForceCompleteProfile')
      this.$store.dispatch('profile/updateShowModal')
    },
    checkBrowserCompability () {
      if (process.client) {
        this.ram = navigator.deviceMemory
        const browserName = DetectRTC.browser.name
        const browserObject = DetectRTC.browser
        const mobileScreen = window.screen.width <= 600 || window.screen.height <= 600
        this.osName = DetectRTC.osName
        this.osVersion = DetectRTC.osVersion.split('.')
        this.isFirefox = DetectRTC.browser.name === 'Firefox'
        this.isMac = this.osName === 'Mac OS X' && this.osVersion[0] >= 14
        const isWindows = (this.osName === 'Windows' && this.osVersion[0] >= 10 && this.ram >= 4)
        const isPC = isWindows || this.isMac
        this.isMobile = /Mobile/.test(navigator.userAgent)
        this.isChrome = (browserName === 'Chrome' || browserName === 'CriOS') && browserObject.version >= 103 && (isPC ? true : !mobileScreen)
        this.isAndroid = (this.osName === 'Android' && this.osVersion[0] >= 11) && (browserName === 'Chrome' && browserObject.version >= 103) && this.ram >= 4
        const webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.appVersion)[1], 10)
        const isGoogle = webkitVer && navigator.vendor.indexOf('Google') === 0
        this.isAndroidDesktopMode = !this.isAndroid && isGoogle && (navigator.platform.includes('Linux a')) && navigator.maxTouchPoints >= 1 && this.ram >= 4
        this.isIphone = /iPhone/.test(navigator.platform) || mobileScreen
        this.isIpad = (this.osName === 'iOS' && this.osVersion[0] >= 15) || ((this.osName === 'Mac OS X' || this.osName === 'iOS') && browserObject.version >= 15)
        this.isEdge = /Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent)
        this.isOpera = /OPR/.test(navigator.userAgent) || /Opr/.test(navigator.userAgent)
        this.isSamsungBrowser = /SamsungBrowser/.test(navigator.userAgent)
        this.isSafari = browserObject.name === 'Safari' && browserObject.version >= 15
        this.isBrave = (navigator.brave && navigator.brave.isBrave()) || false
        const isChromeWindows = this.isChrome && isWindows
        const isChromeMac = this.isChrome && this.isMac
        const isSafariMac = this.isSafari && this.isMac
        const isChromeIpad = this.isChrome && this.isIpad
        const isSafariIpad = this.isSafari && this.isIpad
        const isAndroid = this.isAndroid || this.isAndroidDesktopMode
        const payload = { isChromeWindows, isChromeMac, isSafariMac, isChromeIpad, isSafariIpad, isAndroid }
        this.$store.commit('RTC/SET_DEVICE', payload)
        if (!(((((isChromeWindows || isChromeMac || isSafariMac) || this.isAndroid || this.isAndroidDesktopMode) && !this.isMobile && !mobileScreen) || (isSafariIpad || isChromeIpad)) && !(this.isEdge || this.isOpera || this.isSamsungBrowser || this.isFirefox || this.isBrave || this.isIphone))) {
          this.$router.push('/auth/login')
        }
      }
    },
    trackingNavbar (nav) {
      let event = ''
      switch (nav.path) {
        case '/console/dashboard': event = 'cta_nav_dashboard'
          break
        case '/console': event = 'cta_nav_consultation'
          break
        case '/console/consultation-history': event = 'cta_nav_history'
          break
        case '/console/calendar': event = 'cta_nav_calendar'
          break
        case '/console/finance': event = 'cta_nav_finance'
          break
        case '/console/report': event = 'cta_nav_report'
          break
      }
      this.$tracker({
        action: event,
        category: 'navbar'
      })
    },
    trackTabNotifClick (e) {
      if (e.index === '1') {
        this.$tracker({
          action: 'cta_read_notif',
          category: 'notification'
        })
      } else {
        this.$tracker({
          action: 'cta_unread_notif',
          category: 'notification'
        })
      }
    },
    async goToSchedule (notif) {
      this.isGoToSchedule = true
      const calendar = await {
        start: notif.Clinic.Start * 1000,
        end: notif.Clinic.End * 1000,
        appointmentID: (notif && notif.Appointment) ? notif.Appointment.ID : null
      }
      const currentDate = await this.$moment(calendar.start)

      await this.$store.commit('calendar/NAVIGATE', {
        key: 'start',
        value: currentDate.startOf('week').format('YYYY-MM-DD')
      })

      await this.$store.commit('calendar/NAVIGATE', {
        key: 'end',
        value: currentDate.endOf('week').format('YYYY-MM-DD')
      })

      await this.$nuxt.$emit(
        'navigateCalendar',
        this.$store.state.calendar.navigator.start,
        this.$store.state.calendar.navigator.end
      )

      await this.$store.commit('calendar/CHANGE_SETTING', { key: 'view_type', value: 'week' })
      await this.$store.commit('calendar/CHANGE_SETTING', { key: 'start_day', value: new Date(calendar.start).toISOString() })
      await this.$store.commit('calendar/SET_SELECTED_POP_UP', calendar)
      await this.$router.push('/console/calendar')
    }
  }
}
</script>
<style lang="scss">
#reject-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1041 !important;
  position: fixed;
  background-color: white;
  h2 {
    text-align: center;
    color: #024668;
  }
  .text-green {
    font-size: 1.75rem !important;
    color: #49b191 !important;
  }
}
@media (orientation: landscape) {
  #reject-content {
    display: none;
  }
  #main-content {
    display: block;
  }
}
@media (orientation: portrait) {
  #main-content {
    display: none;
  }
}
.form-group-search {
  display: flex;
  width: 100%;
  position: relative;

  .icon-search {
    position: absolute;
    left: .7rem;
    top: 50%;
    transform: translate(3px, -50%);
  }

  .form-search-notif {
    padding-left: 2.5rem;
    border-radius: 20px !important;
    background-color: #F1F1F1 !important;
  }
}
.tabs-notify {
  .el-tabs__nav {
    width: 100%;
  }
  .el-tabs__header {
    margin-bottom: 0 !important;
  }
  .el-tabs__item {
    width: 50%;
    text-align: center;
    font-family: 'Rubik Medium', sans-serif;
    border-bottom: 3px solid !important;
    border-color: #E3E3E3 !important;
    border-left: none !important;

    &:hover {
      color: #024668 !important;
      border-color: #024668 !important;
      transition: all .5s ease-out;
    }

    &.is-active {
      background-color: #DCF3FD !important;
      color: #024668 !important;
      border-color: #024668 !important;
    }
  }
}
.font-black {
  color: #333;
  max-height: 500px;
  overflow: auto;

  @media screen and (max-width: 1280px) {
    max-height: 300px;
  }
}

.notify-list {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #D8D7D5;
  position: relative;

  &:hover {
    background-color: rgba(79, 195, 247, 0.2);
  }

  &.bg-blue {
    background-color: rgba(79, 195, 247, 0.2);

    &:hover {
      background-color: rgba(124, 211, 250, 0.2);
    }
  }
}
.notify {
  position: relative;
  cursor: pointer;
}

.badge-dot {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #E70016;
  display: inline-block;
}
.kalendar-navigator-custom {
  .btn {
    border: none;
    background: transparent;

    &:hover {
      background: transparent;
    }
  }
}

#customSidebar {
  #sidebar-no-header-title {
    font-family: "Rubik Medium";
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 47px;

    color: #000000;
  }

  .nav {
    margin-top: 20px;

    .nav-item {
      padding: 5px 0 5px 0;
      margin-bottom: 5px;
      .nav-link {
        color: #024668;
        font-size: 14pt;

        img {
          width: 25px;
          margin-right: 10px;
        }
      }
    }
  }
}

.div-flex {
  display: flex;
  justify-content: center;
}
.icon-control {
  width: 100px;
}
.style-sub {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #024668;
}
.style-title {
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  color: #024668;
}
.control-height {
  height: 200px !important;
}
.control-empty {
  position: relative;
  top: 30%;
}
#consoleHeader {
  position: fixed;
  width: 100%;
  background: #fff;
  color: #004569;
  padding: 7px 5px;
  z-index: 30;
  align-items: center;
  justify-content: space-between;
  -webkit-box-shadow: 0 4px 10px -3px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0 4px 10px -3px rgba(0, 0, 0, 0.12);
  box-shadow: 0 4px 10px -3px rgba(0, 0, 0, 0.12);

  .navbar-nav .nav-link {
    color: #004569 !important;
  }

  .navbar-brand {
    img {
      width: 105px;
    }
    @media screen and (max-width: 1200px) {
      img {
        width: 70px;
      }
    }
  }

  #sideMenuBtn {
    width: 30px;
    height: 30px;
    color: #004569;
    background: #fff;
    border-radius: 100%;
    border: 1px solid #b8b8b8;
    padding: 2px;
  }

  .title-console-header {
    font-family: 'Rubik Medium', sans-serif;
    font-weight: 900;
    color: #004569;
    font-size: 18px;
  }
  @media screen and (max-width: 1200px) {
    .title-console-header {
      font-size: 16px;
    }
  }

  .title-version {
    margin-top: -.5rem;
    .beta-watermark {
      background-color: #004569;
      color: #fff;
      border-radius: 4px;
      font-size: 13px;
      padding: 2px 7px;
    }
    .version-watermark {
      font-size: 12px;
      font-family: "Rubik Regular", sans-serif;
      color: #004569;
    }
    @media screen and (max-width: 1200px) {
      .version-watermark {
        font-size: 10px;
      }
    }
  }
}

@media (orientation: portrait) {
  #consoleHeader {
    display: none;
  }
}
.false-style {
  padding: 40px 20px;
}
.here-style {
  color: #ffffff !important;
  background: #024668;
  font-size: 14px;
  border-radius: 20px;
}
.here-style .nav-link {
  color: #ffffff !important;
}
.z-1000 {
  z-index: 1061 !important;
}
#dropdown-share-social button {
  background-color: white !important;
  width: 30px;
  padding: 0;
  border-radius: 50%;
}
.help-class {
  background: #00C300 !important;
  border: 0.964764px solid #00C300 !important;
  box-sizing: border-box !important;
  border-radius: 15.2416px !important;
  padding: 2px 12px !important;
}
.notification-button {
  width: 30px;
  padding: 0 !important;
  border-radius: 50% !important;
  height: 30px;
}

.notification-telegram-button {
  width: 32px;
  height: 32px;
  padding: 0 !important;
  border-radius: 50% !important;
}

.notification-telegram {
  background: #FCED03 !important;
  .popper__arrow::after {
    border-bottom-color: #FCED03 !important;
  }
}

@media (orientation: portrait) {
//   #main-content {
//     display: none;
//   }
  .notification-telegram {
    display: none;
  }
}

@media (min-width: 768px) {
  #dropdown-share-social .dropdown-menu {
    position: absolute;
    left: -75px !important;
  }
}

.navbar-content {
  display: flex;
  justify-content: center;
  align-items: center;

  .pop-position {
    left: 0;
    right: 0;
    top: 65px;
  }

  .list-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #1A5CAC;
    border-radius: 4px;
    padding: 1rem;
    text-transform: uppercase;
    font-weight: 500;

    @media screen and (min-width: 992px) {
      flex-direction: column;
      padding: .3rem .8rem;
    }

    &:hover {
      background-color: #eaeaea;
    }

    &.active {
      background-color: #1A5CAC;
      color: #fff;
    }

    .list-image {
      width: 28px;
      margin-bottom: .3rem;
    }
    .list-title {
      font-size: 14px;
    }
    @media screen and (max-width: 1200px) {
      .list-title {
        font-size: 12px;
      }
    }
  }
}

.modalOTP {
  .img-close {
    position: absolute;
    right: 15px;
    z-index: 100;
    top: 0;
  }
  .modal-verification {

    .text-title {
      font-style: normal;
      font-weight: bold;
      font-size: 36px !important;
      line-height: 42px;
      align-items: center;
      text-align: center;
      color: #434343;
    }

    .text-subtitle {
      font-style: normal;
      font-weight: normal;
      font-size: 28px;
      line-height: 36px;
      align-items: center;
      text-align: center;
    }

    .text-phone {
      color: #00C300;
    }

    .button-verification {
      background: #00C300 !important;
      border-radius: 9.95426px !important;
      font-style: normal;
      font-weight: 500;
      font-size: 36px !important;
      line-height: 21px;
      align-items: center;
      padding: 25px;
      width: 100%;
    }

    .button-verification:hover {
      background: #00C300 !important;
      border-radius: 9.95426px !important;
      font-style: normal;
      font-weight: 500;
      font-size: 36px !important;
      line-height: 21px;
      align-items: center;
      padding: 25px;
      width: 100%;
    }

    .text-green {
      color: #00C300 !important;
      font-size: 20px;
      cursor: pointer;
    }

    .text-red {
      color: #E70016;
    }

    .button-grey {
      background: #C5C3BF !important;
    }

    .button-grey:hover {
      background: #C5C3BF !important;
    }

    .otp-input {
      width: 80px;
      height: 80px;
      padding: 5px;
      margin: 0 10px;
      font-size: 90px;
      border: 0px;
      border-bottom: 5px solid rgba(0, 0, 0, 0.3) !important;
      text-align: center;
      &.active {
        border-bottom: 5px solid #00C300 !important;
      }
      &.error {
        border: 1px solid red !important;
      }
    }
    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

.modalPhone {
  max-width: 400px !important;

  .img-close {
    position: absolute;
    right: 15px;
    z-index: 100;
    top: 0;
  }
  .modal-phone {
    padding: 0px 30px;
    .text-title {
      font-style: normal;
      font-weight: bold;
      font-size: 24px !important;
      line-height: 38px;
      align-items: center;
      text-align: center;
      color: #434343;
    }

    .text-subtitle {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 24px;
      align-items: center;
      text-align: center;
    }
    .text-phone {
      color: #00C300;
    }

    .button-verification {
      background: #00C300 !important;
      border-radius: 40px !important;
      font-style: normal;
      font-weight: 500;
      font-size: 24px !important;
      line-height: 21px;
      align-items: center;
      padding: 20px;
      width: 80%;
    }
  }
}

.profile-image {
  width: 45px;
  height: 45px;
  min-width: 45px;
  min-height: 45px;
  max-height: 45px;
  max-width: 45px;
}

.break-word {
  word-break: break-word !important;
  width: 100%;
  display: block;
}

.time-position {
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.modalUnlink {
  .box {
    padding: 49px 62px 43px 62px;
    img {
      margin-bottom: 20px;
    }
    .description {
      font-family: 'Rubik Regular';
      font-size: 18px;
      line-height: 21px;
      text-align: center;
    }
  }
}
</style>
